import { type PropsWithChildren, type FC, useState } from 'react';
import * as uuid from 'uuid';
import { Form, Badge } from 'react-bootstrap';
import { BsCaretDown, BsX } from 'react-icons/bs';

import { configCard } from './styles';

interface Props extends PropsWithChildren {
	title: string;
	enabled?: boolean;
	overrideTitle?: string;
	override?: boolean;
	setOverride?: (value: boolean) => void;
	removable?: boolean;
	remove?: () => void;
	collapsed?: boolean;
}

const ConfigCard: FC<Props> = (props) => {
	const { title, enabled, overrideTitle, override, setOverride, removable, remove, children } =
		props;

	const [collapsed, setCollapsed] = useState(props.collapsed == null || props.collapsed === true);

	return (
		<div className={configCard}>
			<div className={`cardHeader ${!collapsed && 'expanded'}`}>
				<div className="configCardTitle">
					<div>
						{removable && (
							<BsX
								onClick={() => {
									remove();
								}}
							/>
						)}
					</div>
					<div className="titleText">{title}</div>
				</div>

				<div className="tools">
					{setOverride && (
						<Form.Check
							id={uuid.v4()}
							type="switch"
							checked={override}
							onChange={() => setOverride(!override)}
							label={overrideTitle || 'Override Resource Config'}
							className="overrideSwitch"
						/>
					)}
					{enabled !== null &&
						(enabled ? (
							<Badge variant="success">enabled</Badge>
						) : (
							<Badge variant="secondary">disabled</Badge>
						))}

					<BsCaretDown
						onClick={() => setCollapsed(!collapsed)}
						className={collapsed ? 'collapseIconRotate' : 'collapseIcon'}
					/>
				</div>
			</div>

			{!collapsed && <div className="cardBody">{children}</div>}
		</div>
	);
};

export default ConfigCard;
